import { GLTFLoader} from 'three/examples/jsm/Addons.js'
import { createMaterials } from './materials'


export let targets = []
export let bubbles = {}
export let titles = {}
export let board = null
export let objectsScale = {}
export let squares = null

export const modelLoader = (scene, loadingManager, groupDefault) =>{

const gltfLoader = new GLTFLoader(loadingManager)

const materials = createMaterials(groupDefault)

const othersInteractivesElements = {
    board: {scale: 1.18, position: 1}, 
    drawer: {position: 2, amplitudX: 0.02, amplitudY: 0.02, amplitudZ: 0.02, scaleBase: 1, speed: 4},
    screenTv: {nameBubble: 'smallBubbleTv'}, 
    mountain: {nameBubble: 'smallBubbleMountain', amplitudX: 0, amplitudY: 0.06, amplitudZ: 0.06, scaleBase: 1, speed: 4}, 
    skull: {nameBubble: 'smallBubbleSkull', amplitudX: 0, amplitudY: 0.05, amplitudZ: 0, scaleBase: 1, speed: 4},
    radio: {amplitudX: 0, amplitudY: 0.11, amplitudZ: 0, scaleBase: 1, speed: 5}
}

gltfLoader.load('/model/miCasita.glb', (gltf)=>{
   const model = gltf.scene 

   model.traverse((child) =>{
        if(materials.hasOwnProperty(child.name)){
          child.material = materials[child.name]
        } 

        if(child.name.includes('Bubble')){
            child.visible = false
            bubbles[child.name] = child
        }

        if(child.name.includes('sticker') || child.name.includes('title')){
            child.material = materials.groupFive
            child.userData.scaleRaycaster = child.name.includes('sticker') ? 1.5 : 1.28
            targets.push(child)

            if(child.name.includes('title')){
                titles[child.name] = child
                child.visible = false
            }
        }

        if(othersInteractivesElements[child.name]){
            const data = othersInteractivesElements[child.name]
            Object.assign(child.userData, {
                ...(data.scale !== undefined && {scaleRaycaster: data.scale}), 
                ...(data.position !== undefined && {positionCamera: data.position}),
                ...(data.nameBubble !== undefined && {nameBubble: data.nameBubble}),
                ...(data.amplitudX !== undefined && {amplitudX: data.amplitudX}),
                ...(data.amplitudY !== undefined && {amplitudY: data.amplitudY}),
                ...(data.amplitudZ !== undefined && {amplitudZ: data.amplitudZ}),
                ...(data.scaleBase !== undefined && {scaleBase: data.scaleBase}),
                ...(data.speed !== undefined && {speed: data.speed}),
            })
               targets.push(child)       
        }

        switch (child.name) {
            case 'squares': 
                squares= child
                break
            case 'drawer':
            case 'radio':
            case 'skull':
            case 'mountain':
               objectsScale[child.name] =  child
                break
            case 'board': 
                board = child
                break
        }
 })
     scene.add(model)
})
    return materials
}

